export enum OrderDirection {
    Long,
    Short
  }
  